export const computeRetryDelayMs = (attempt, random, backoff)=>Math.min(backoff.baseMs * 2 ** attempt, backoff.capMs) * (1 + (2 * random - 1) * backoff.jitterRatio);
export const retryCountdownSeconds = (attempt, random, backoff)=>Math.ceil(computeRetryDelayMs(attempt, random, backoff) / 1000);
export const NETWORK_RETRY_SCHEDULE = {
    baseMs: 2000,
    capMs: 30000,
    jitterRatio: 0.25,
    random: Math.random,
    startTicker: (onTick)=>{
        const interval = setInterval(onTick, 1000);
        return ()=>clearInterval(interval);
    }
};
